import { applovinDashboardApi } from '../api/applovinDashboard';
import AppLikeDeliveryDashboard, { fmtInt, fmtNum, fmtPct } from './AppLikeDeliveryDashboard';

const METRICS = [
  { key: 'impressions', label: '展示次数', fmt: fmtInt },
  { key: 'clicks', label: '点击次数', fmt: fmtInt },
  { key: 'ctr', label: '账户CTR', fmt: fmtPct },
  { key: 'cpc', label: '账户CPC', fmt: (v: number) => fmtNum(v), permKey: 'cpc' },
  { key: 'spend', label: '账户花费', fmt: (v: number) => fmtNum(v), permKey: 'spend' },
  { key: 'cpm', label: '账户CPM', fmt: (v: number) => fmtNum(v), permKey: 'cpm' },
  { key: 'purchases', label: '购物次数', fmt: fmtInt },
  { key: 'revenue', label: '购物转化价值', fmt: (v: number) => fmtNum(v), permKey: 'revenue' },
  { key: 'cpa', label: '账户CPA', fmt: (v: number) => fmtNum(v), permKey: 'cpa' },
  { key: 'account_roi', label: '账户ROI', fmt: (v: number) => fmtNum(v), permKey: 'roas' },
  { key: 'aov', label: '账户单均价', fmt: (v: number) => fmtNum(v), permKey: 'revenue' },
  { key: 'click_purchase_rate', label: '点击购买率', fmt: fmtPct },
] as const;

export default function ApplovinDeliveryDashboard() {
  return (
    <AppLikeDeliveryDashboard
      storageKey="applovin_dashboard_hidden_cols"
      platformLabel="Applovin"
      reportKey="ad_dashboard_applovin_overview"
      supportedRegions={['us']}
      getOverview={applovinDashboardApi.getOverview}
      metrics={METRICS as any}
    />
  );
}
